import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  screenTitle: {
    defaultMessage: 'Details',
    description: 'Product Details | Screen title',
  },
  goBack: {
    defaultMessage: 'Go back',
    description: 'Product Details | Go back',
  },
  ingredientHighlightsTitle: {
    defaultMessage: 'Ingredient Highlights',
    description: 'Product Details | Ingredient highlights title',
  },
  nutritionInfoTitle: {
    defaultMessage: 'Nutrition Info',
    description: 'Product Details | Nutrition Info title',
  },
  addToBag: {
    defaultMessage: 'Add to bag',
    description: 'Product Details | Add to bag button | Title',
  },
  changeLocation: {
    defaultMessage: 'Change location to order',
    description: 'Product Details | Change location to order button | Title',
  },
  selectLocation: {
    defaultMessage: 'Select location to order',
    description: 'Product Details | Select location to order button | Title',
  },
});
